<div class="wrapper-page wrapper-my-list" style="color: white;">
  <tl-header></tl-header>
  <div class="wrapper-header-my-lists">
    <div class="header-my-lists">
      <span>
        {{'LISTS.recommended_lists' | translate}}
      </span>
    </div>
  </div>
  <div class="wrapper-content-my-lists favorite-lists">
    <div class="content-my-lists">
      <div class="filter-my-lists">
        <div class="wrapper-custom-search">
          <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
          <input type="text" placeholder="{{'NEW_TEXT.search' | translate}}"  [(ngModel)]="searchTerm" (input)="onSearchChange($event)">
          <div (click)="resetSearch()" class="wrapper-delete-search">
            <img src="../../../assets/icons/outline/icon-close.svg" alt="">
          </div>
        </div>
      </div>
      <div #recommendedListsContainter (scroll)="onScroll()" class="wrapper-cards-list">
      <div *ngFor="let list of recommendedLists" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']"  class="wrapper-card-list">
          <img class="image-list" [src]="list.lyst_image_url !== null ? list.lyst_image_url : 'assets/images/no-image.png'"  alt="">
          <div class="wrapper-card-list-info">
            <div class="wrapper-badges">
              <div class="badge gray">
                <span>{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items' | translate) : ('LISTS.items' | translate)}}</span>
              </div>
            </div>
            <span class="name-list">{{list | matchLocale}}</span>
            <div class="author-recommended-list">
              <span>{{list.user.name}}</span>
              <img *ngIf="(list.user.subscriptions | checkActiveRole) === UserRoles.expert" src="./assets/icons/fill/icon-badge.svg" alt="">
              <img *ngIf="(list.user.subscriptions | checkActiveRole) === UserRoles.company" src="./assets/icons/fill/icon-fill-company.svg" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
